/**
 * Labstep
 *
 * @module state/new/print
 * @desc Selectors/Reducers for Print
 */

import type { Action } from 'labstep-web/models/action.model';
import type { LabstepReduxState } from 'labstep-web/state/types';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

// Root print state (matches combineReducers structure)
export interface StatePrint {
  progress: number;
}

// WebSocket message payload for print events
interface PrintWebSocketPayload {
  type: 'print';
  [key: string]: any;
}

// Generic WebSocket message structure
interface WebSocketMessage {
  type: string;
  payload?: PrintWebSocketPayload;
  [key: string]: any;
}

// Action meta structure for print progress updates
interface PrintProgressMeta {
  progress: number;
  [key: string]: any;
}

// Print-related action types
interface PrintWebSocketAction {
  type: 'WEBSOCKET_MESSAGE';
  payload?: PrintWebSocketPayload;
}

interface CreateEntityExportAction {
  type: 'SUCCESS_CREATE_ENTITY_EXPORT_RAW_OUTPUT';
  payload?: any;
}

interface UpdatePrintProgressAction {
  type: 'UPDATE_PRINT_PROGRESS';
  meta?: PrintProgressMeta;
  payload?: any;
}

// Union type for all print-related actions
export type PrintAction =
  | PrintWebSocketAction
  | CreateEntityExportAction
  | UpdatePrintProgressAction;

// Print state interface
export interface PrintState {
  progress: number;
}

export const selectPrintProgress = createSelector(
  (state: LabstepReduxState) => (state.print as any).progress,
  (progress: number) => progress,
);

/**
 * Print progress (every 30 seconds elasped since user asked for a print).
 */
export const progress = (state = 0, action: Action): number => {
  if (
    action.type === 'WEBSOCKET_MESSAGE' &&
    action.payload &&
    action.payload.type === 'print'
  ) {
    return -1;
  }
  if (action.type === 'SUCCESS_CREATE_ENTITY_EXPORT_RAW_OUTPUT') {
    return 0;
  }
  if (
    action.type === 'UPDATE_PRINT_PROGRESS' &&
    action.meta &&
    action.meta.progress
  ) {
    return action.meta.progress as any;
  }

  return state;
};

export const printReducers = combineReducers({
  progress,
});
